export default {
  'timeSelect.lastDay': '1 Hari Lalu',
  'timeSelect.last7Day': '7 Hari Terakhir',
  'timeSelect.lastMonth': '1 Bulan Lalu',
  'timeSelect.thisMonth': 'Bulan Ini',
  'timeSelect.userDefined': 'Pilih Rentang Tanggai',
  'timeSelect.SelectAll': 'Select All',
  'timeSelect.DeselectAll': 'Deselect All',
};
